'use strict'

module.exports = value =>
  value == null || typeof value.toString !== 'function'
    ? ''
    : Array.isArray(value)
    ? value.join(', ')
    : value.toString()
